var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { CLOSE_STATUS, NOT_INSURED_ISSUER_SLUG, USER_INTENT, defaultShowLogos, notInsuredIssuer, otherIssuer, } from "../../lib/constants";
import { EXPERIENCE, InsuranceProducts, InsuranceType } from "../../constants";
import { clickedNoInsurance, clickedSearchIssuers, completedPage, } from "../../lib/Avo";
import { prefillUserSelectedOtherIssuer, selectAutoIssuer, } from "../../features/applicant/applicantSlice";
import AppBody from "../../components/AppBody";
import Header from "../../components/Header";
import RouteHeaderLogo from "../../components/RouteHeaderLogo";
import SelectIssuerList from "../../components/SelectIssuerList";
import { batch } from "react-redux";
import { enteredUnlinkedApplication } from "../../features/unlinked-application/unlinkedApplicationSlice";
import { updateCommonAnalyticProperty } from "../../features/analytics/analyticsSlice";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import useApplication from "../../features/configuration/useApplication";
import useCanShowMidFunnelAds from "../../features/configuration/useCanShowMidFunnelAds";
import useCloseClickHandler from "../../hooks/useCloseClickHandler";
import { useEffectOnceWhen } from "rooks";
import { useGetIssuersQuery } from "../../services/savvy";
import { useHistory } from "react-router-dom";
import useIsSupportedIssuer from "../../hooks/useIsSupportedIssuer";
import useSelectedIssuerNextRoute from "../../features/applicant/useSelectedIssuerNextRoute";
export default function SelectAutoIssuerRoute() {
    var application = useApplication();
    var enableFormExperience = useAppSelector(function (state) { return state.configuration; }).enableFormExperience;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var currentIssuer = useAppSelector(function (state) { return state.applicant.currentIssuer.auto; });
    var _a = React.useState(false), goToNextRoute = _a[0], setGoToNextRoute = _a[1];
    var getSelectedIssuerNextRoute = useSelectedIssuerNextRoute("auto");
    var dispatch = useAppDispatch();
    var push = useHistory().push;
    var _b = useGetIssuersQuery().data, issuerList = _b === void 0 ? [] : _b;
    var canShowMidFunnelAds = useCanShowMidFunnelAds();
    var closeClickHandler = useCloseClickHandler();
    var isSupportedIssuer = useIsSupportedIssuer();
    var isPrefillUser = useAppSelector(function (state) { return state.configuration.experience === EXPERIENCE.PREFILL; });
    function handleSelectIssuer(issuer) {
        var isSupported = isSupportedIssuer(issuer);
        var isInsured = issuer.id !== NOT_INSURED_ISSUER_SLUG;
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: issuer.name, optionSelected: issuer.name }));
        batch(function () {
            dispatch(selectAutoIssuer(issuer));
            if (issuer.id === otherIssuer.id && isPrefillUser) {
                dispatch(prefillUserSelectedOtherIssuer({ auto: true }));
            }
            if (!isSupported) {
                dispatch(enteredUnlinkedApplication("unsupported-issuer"));
            }
            if (!isInsured) {
                dispatch(enteredUnlinkedApplication("not-insured"));
            }
        });
        setGoToNextRoute(true);
    }
    function handleCloseClick(issuer) {
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: issuer.name, optionSelected: issuer.name }));
        batch(function () {
            dispatch(selectAutoIssuer(issuer));
            dispatch(enteredUnlinkedApplication("unsupported-issuer"));
        });
        if (canShowMidFunnelAds || enableFormExperience) {
            setGoToNextRoute(true);
        }
        else {
            closeClickHandler({
                status: CLOSE_STATUS.issuer_not_found,
                userIntent: USER_INTENT.PROCEED_MANUALLY,
            });
        }
    }
    React.useEffect(function () {
        if (!commonAnalyticsProperties.shoppingIntent) {
            dispatch(updateCommonAnalyticProperty({
                shoppingIntent: InsuranceProducts.Auto,
            }));
        }
    }, [commonAnalyticsProperties.shoppingIntent, dispatch]);
    useEffectOnceWhen(function () {
        if (currentIssuer) {
            var nextRoute = getSelectedIssuerNextRoute(currentIssuer);
            if (nextRoute) {
                push(nextRoute);
            }
        }
    }, goToNextRoute && currentIssuer !== null);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement(SelectIssuerList, { title: "Who insures your car today?", issuers: issuerList, initialIssuers: defaultShowLogos, insuranceType: InsuranceType.Auto, handleSelectIssuer: handleSelectIssuer, onCloseClick: handleCloseClick, issuerListLastNode: function (_a) {
                    var inputRef = _a.inputRef;
                    return (React.createElement("button", { onClick: function () {
                            clickedSearchIssuers(commonAnalyticsProperties);
                            if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
                                inputRef === null || inputRef === void 0 ? void 0 : inputRef.current.focus();
                            }
                        }, className: "py-4 text-center font-bold text-black-100 underline", "data-cy": "issuer-search-button" }, "Don't see your carrier? Search instead"));
                }, onFooterClick: function (ev) {
                    var _a, _b;
                    clickedNoInsurance(commonAnalyticsProperties);
                    if ((_a = application.not_insured_link) === null || _a === void 0 ? void 0 : _a.close_status) {
                        completedPage(__assign(__assign({}, commonAnalyticsProperties), { optionSelected: ev.currentTarget.textContent, selectedOption: ev.currentTarget.textContent }));
                        return closeClickHandler({
                            status: (_b = application.not_insured_link) === null || _b === void 0 ? void 0 : _b.close_status,
                            userIntent: USER_INTENT.PROCEED_MANUALLY,
                        });
                    }
                    handleSelectIssuer(notInsuredIssuer);
                } }))));
}
